//#region Components
import DialogCheckInTimeQuestion from "../DialogCheckInTimeQuestion/DialogCheckInTimeQuestion";
import DialogNotifyNotCheckedOutTime from "../DialogNotifyNotCheckedOutTime/DialogNotifyNotCheckedOutTime";
import TeacherAttendanceClassDetail from "./components/TeacherAttendanceClassDetail";
import TeacherAttendancePlaceholder from "./components/TeacherAttendancePlaceholder";
//#endregion
//#region Utils
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import useDataTeacherAttendance from "./utils/hooks/useDataTeacherAttendance";
import useAskTeacherTakeAttendance from "./utils/hooks/useAskTeacherTakeAttendance";
import useDisableForCheckTimeButton from "./utils/hooks/useDisableForCheckTimeButton";
import useTeacherName from "./utils/hooks/useTeacherName";
import useTakeTeacherAttendance from "./utils/hooks/useTakeTeacherAttendance";
//#endregion

/*
NOTA: Considerar dialogCheckOutTimeQuestion y dialogNotifyNotCheckedOutTimeToStudentAttendance si se llega a requerir la marcación de salida.
*/
const TakeTeacherAttendancePanel = ({
	loadingRequest,
	studentReservations,
	eventData,
}) => {
	const dialogCheckInTimeQuestion = useShowDialogAlert();
	// const dialogCheckOutTimeQuestion = useShowDialogAlert();
	const dialogNotifyNotCheckedOutTimeToStudentAttendance =
		useShowDialogAlert();
	const dataTeacherAttendance = useDataTeacherAttendance({
		eventData,
	});
	const teacherName = useTeacherName();
	const askTeacherTakeAttendance = useAskTeacherTakeAttendance({
		dialogCheckInTimeQuestion,
		// dialogCheckOutTimeQuestion,
		// dialogNotifyNotCheckedOutTimeToStudentAttendance,
		loadingRequest,
		// studentReservations,
	});
	const disableForCheckTimeButton = useDisableForCheckTimeButton({
		eventData,
	});
	const takeTeacherAttendance = useTakeTeacherAttendance({
		loadingRequest,
		eventData: eventData.value,
		fillTeacherAttendanceData: dataTeacherAttendance.fill,
	});
	if (!dataTeacherAttendance.isLoaded) return null;
	return (
		<>
			{dataTeacherAttendance.isComplete() ? (
				<TeacherAttendanceClassDetail
					teacherName={teacherName}
					dataTeacherAttendance={dataTeacherAttendance.value}
				/>
			) : (
				<TeacherAttendancePlaceholder
					teacherName={teacherName}
					dataTeacherAttendance={dataTeacherAttendance}
					askTeacherTakeAttendance={askTeacherTakeAttendance}
					disableForCheckTimeButton={disableForCheckTimeButton}
				/>
			)}
			<DialogNotifyNotCheckedOutTime
				dialog={dialogNotifyNotCheckedOutTimeToStudentAttendance}
			/>
			<DialogCheckInTimeQuestion
				dialog={dialogCheckInTimeQuestion}
				serverTime={askTeacherTakeAttendance.serverTime}
				takeTeacherAttendance={takeTeacherAttendance}
			/>
			{/* <DialogCheckOutTimeQuestion
				dialog={dialogCheckOutTimeQuestion}
				serverTime={askTeacherTakeAttendance.serverTime}
				takeTeacherAttendance={takeTeacherAttendance}
			/> */}
		</>
	);
};

export default TakeTeacherAttendancePanel;
